import { css } from "lit";

export const worldFormModalStyles = css`
  .modal-content {
    width: 100%;

    margin: 0 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .form-layout {
    display: grid;
    gap: 40px;
    overflow: hidden;
  }

  .world-form {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* Desktop: single row, 2 columns */
  @media (min-width: 768px) {
    .form-layout {
      grid-template-areas: "left-column right-column";
      grid-template-columns: 1fr 1fr;
    }

    .left-column,
    .right-column {
      overflow-y: auto;
      max-height: calc(90vh - 200px); /* Account for header, footer, and padding */
    }
  }

  /* Mobile: single column stack */
  @media (max-width: 767px) {
    .form-layout {
      overflow: auto;
      grid-template-areas:
        "left-column"
        "right-column";
      grid-template-columns: 1fr;
    }

    /* Ensure columns don't have individual scrolling on mobile */
    .left-column,
    .right-column {
      overflow: visible;
      max-height: none;
    }
  }

  .left-column {
    grid-area: left-column;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .right-column {
    grid-area: right-column;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .thumbnail-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .posts-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
  }

  .posts-section-title {
    font-size: var(--sds-size-text-body-small-font-size);
    font-weight: var(--sds-size-text-body-small-font-weight);
    line-height: var(--sds-size-text-body-small-line-height);
    color: var(--sds-color-text-default-primary);
    margin: 0;
  }

  .selected-counter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: var(--sds-color-background-default-secondary);
    border-radius: 2px;
    position: sticky;
    bottom: 0;

    font-size: var(--sds-typography-body-size-medium);
    z-index: 2;
  }
`;
